<template functional>
  <span v-if="props.isPresentation" class="menu-title">
    {{ props.text }}
  </span>
  <a
    v-else
    class="menu-title"
    :href="props.url"
    v-bind="data.attrs"
    v-on="listeners"
  >
    {{ props.text }}
  </a>
</template>

<script>
export default {
  name: 'NavTitle',

  props: {
    isPresentation: {
      type: Boolean,
      default: false
    },
    text: String,
    url: {
      String,
      optional: true
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-title {
  display: block;
  font-weight: 700;
  letter-spacing: 0.3px;
  padding: 10px 15px;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}
</style>
